<template>
  <div>
    <div class="form-fields col-md">
      <fieldset>
        <legend>{{title}}</legend>

        <br />

        <div class="row">
          <div class="col">
            <div class="form-group">
              <label class="control-label">
                The Cook County Demolition Debris Diversion (DDD) Ordinance requires reuse and recycling of material consistent with the Cook County Solid Waste Plan. Demolition debris diversion shall be required for all demolition activities affecting any structure except garages, sheds, utilities, and projects that are not demolishing any load bearing walls.
                Prior to the commencement of a demolition project, the demolition permit holder must submit a Demolition Debris Diversion Plan, in a manner prescribed by the Department, estimating the respectively required diversion goals and the transport means and destinations of demolition debris.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">
                Please enter the  total actual quantity recycled below:
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <label class="required">Estimate Amount</label>
            <div class="form-group">
              <div class="input-group">
                <input type="number"
                       disabled
                       class="form-control"
                       placeholder="0.00"
                       min="0"
                       v-model="form.materialEstimate" />
                <div class="invalid-feedback" v-if="isTotalPercentageError(index)">
                  Estimates for diversion are required to be at least 70% of the total estimated weight
                </div>
                <div class="invalid-feedback" v-if="isMaterialSumGreaterError()">
                  Must be greater than or equal to total material amounts
                </div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <label class="required">Actual Amount</label>
            <div class="form-group">
              <div class="input-group">
                <input type="number"
                       :disabled="form.finalized"
                       class="form-control"
                       :class="{ 'is-invalid': isTotalPercentageError(index) || isTotalPercentageMaxError(index)}"
                       placeholder="0.00"
                       min="0"
                       v-model="form.materialActual" />
                <div class="invalid-feedback" v-if="isTotalPercentageError(index)">
                  Actuals for diversion are required to be at least 70% of the total actual weight
                </div>
                <div class="invalid-feedback" v-if="isTotalPercentageMaxError(index)">
                  The total sum of material weights cannot exceed entered actual total quantity
                </div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <label>Measure</label>
            <div class="form-group">
              <div class="input-group">
                <input type="text"
                       class="form-control"
                       disabled
                       placeholder="Tons" />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">
                Please enter the actual quantities recycled by material below. You can save and return later if you are only making partial updates. Click the submit button once you've made all updates to finalize the project:
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3" v-for="(material, index) in form.materials" :key="material.uuid">
          <b-button v-on:click="openMaterial(index);" variant="primary">Material {{index + 1}} </b-button>
          <b-collapse :id="`collapse-${index}`" class="mt-2">
            <b-card>
              <div class="row">
                <div class="col-6">
                  <label class="required">Material Name</label>
                  <div class="form-group">
                    <div class="input-group">
                      <select class="form-control"
                              :disabled="material.id"
                              :class="{ 'is-invalid': isMaterialNameError(index) }"
                              @change="resetMaterialOverrideName(index)"
                              v-model="material.materialType">
                        <option v-for="m in materials">{{m.name}}</option>
                      </select>
                      <div class="invalid-feedback" v-if="isMaterialNameError(index)">
                        A Name Is Required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <label class="required">Estimated Amount</label>
                  <div class="form-group">
                    <div class="input-group">
                      <input type="number"
                             class="form-control"
                             placeholder="0.00"
                             min="0"
                             :disabled="true"
                             :class="{ 'is-invalid': isMaterialAmountError(index) }"
                             v-model="material.quantityEstimate" />
                      <div class="invalid-feedback" v-if="isMaterialAmountError(index)">
                        An Amount Is Required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <label>Measure</label>
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text"
                             class="form-control"
                             v-model="material.unitofMeasure"
                             disabled
                             placeholder="Tons" />
                    </div>
                  </div>
                </div>
                <div class="col-1" v-if="!form.finalized">
                  <label></label>
                  <div class="form-group mt-2">
                    <button class="btn btn-danger" title="Remove Item" v-on:click="removeMaterial(index);" v-b-tooltip.hover>
                      <font-awesome-icon icon="times" />
                    </button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label class="required">Actual Amount</label>
                  <div class="form-group">
                    <div class="input-group">
                      <input type="number"
                             :disabled="form.finalized"
                             v-bind:id="`actual-${index}`"
                             class="form-control required"
                             @change="isActualsError(index)"
                             :class="{ 'is-invalid': isMaterialActualError(index) }"
                             v-model="material.quantityActual"
                             placeholder="Actual Quantity" />
                      <div class="invalid-feedback" v-if="isMaterialActualError(index)">
                        An Actual Amount Is Required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6" v-if="material.materialType === 'Other'">
                  <label class="required">Material Description</label>
                  <div class="form-group">
                    <div class="input-group">
                      <input type="text"
                             class="form-control"
                             placeholder="Material Description"
                             :class="{ 'is-invalid': isOtherDescriptionError(index) }"
                             :disabled="material.id"
                             v-model="material.overrideName" />
                      <div class="invalid-feedback" v-if="isOtherDescriptionError(index)">
                        An Material Description Is Required
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <label class="required">Recycling Facility Name</label>
                  <vue-simple-suggest :list="facilities"
                                      mode="input"
                                      v-model="material.facilityName"
                                      :placeholder="'Recycling Facility Name'"
                                      value-attribute="id"
                                      display-attribute="name"
                                      :filter-by-query="true"
                                      :class="{ 'is-invalid': isFacilityNameError(index) }"
                                      @select="facilitySelected">
                    <div class="input-group">
                      <input :class="{ 'is-invalid': isFacilityNameError(index) }" type="text" class="form-control" v-model="material.facilityName" :disabled="form.finalized" @change="facilitySelected(null)" />
                      <div class="invalid-feedback" v-if="isFacilityNameError(index)">
                        An Faciltiy Name Is Required
                      </div>
                    </div>
                  </vue-simple-suggest>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col" v-if="!form.finalized">
                  <label>Upload File:</label><label style="color: red" v-if="showAstrisk != null && showAstrisk[material.uuid] == true">*</label>
                  <base-file-uploader v-model="material.receiptFile"
                                      v-if="!form.finalized"
                                      :file="material.receiptFile"
                                      :validation="val.form.materials.receiptFile"
                                      v-bind:id="`receiptFile-${index}`" />
                </div>
                <div class="col">
                  <label v-if="!form.finalized && material.documentName" id="`receiptFile-${index}`">Current File Uploaded</label>
                  <input v-if="!form.finalized && material.documentName" type="text" class="form-control" disabled :value="material.documentName" />
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>

        <br />

        <div class="row" v-if="!form.finalized">
          <div class="col">
            <div class="form-group">
              <button class="btn btn-primary" v-on:click="addMaterial();">
                <font-awesome-icon icon="plus" />&nbsp;Add Additional Material(s)
              </button>
            </div>
          </div>
        </div>

        <br />

      </fieldset>

      <label>To convert Pounds to Tons, divide pounds by 2000. To convert Cubic Yards to Tons, multiply cubic yards by 1.4</label>
    </div>
  </div>
</template>
<script>
  import BaseInput from '~/components/BaseInput'
  import ExplodedFieldset from '~/components/ExplodedFieldset'
  import VAddress from '~/components/VAddress'
  import BottomNav from '~/components/BottomNavigation'
  import BaseTimePicker from '~/components/BaseTimePicker'
  import BaseDatePicker from '~/components/BaseDatePicker'
  import BaseCheckbox from '~/components/BaseCheckbox'
  import BaseTextarea from '~/components/BaseTexarea'
  import YesNo from '~/components/YesNo'
  import { getFacilities, getMaterials, capitalize, isNullOrEmpty } from '~/js/FormFunctions'
  import { CapitalizeFilter } from '@/js/Mixins'
  import VueSimpleSuggest from 'vue-simple-suggest'
  import BaseSelect from '~/components/BaseSelect'
  import BaseFileUploader from '~/components/BaseFileUploader'
  import { Material } from '../../js/FormObjects'
  import { forEach } from 'lodash/fp'


  export default {
    name: 'Facility',
    components: {
      BaseFileUploader,
      BaseSelect,
      BaseInput,
      ExplodedFieldset,
      VAddress,
      BottomNav,
      VueSimpleSuggest,
      BaseTimePicker,
      YesNo,
      BaseDatePicker,
      BaseTextarea,
      BaseCheckbox
    },
    props: ['form', 'val', 'stateList'],
    mixins: [CapitalizeFilter],
    data() {
      return {
        facilities: [],
        materials: [],
        originalActuals: [],
        currMaterialIndex: 0,
        partialFullDemoOptions: [
          { value: null, text: '' },
          { value: 'F', text: 'Full Demolition' },
          { value: 'P', text: 'Partial Demolition' }
        ],
        autosuggestProps: {
          id: 'facility-suggest',
          onInputChange: this.inputChange
        },
        showAstrisk: []
      }
    },
    beforeMount() {

    },
    mounted() {
      this.$emit('update:title', 'Demolition Debris Diversion Ordinance Plan')
      this.facilities = this.$store.getters.facilities()
      if (!this.facilities || this.facilities.length === 0) {
        const self = this
        this.$emit('update:fetchingData', true)
        getFacilities()
          .then((response) => {
            self.facilities = response
            self.$emit('update:fetchingData', false)

            for (var i = 0; i < this.$props.form.materials.length; i++) {
              this.$props.form.materials[i].facilityName = self.facilities.find(o => o.id === this.$props.form.materials[i].linktoRecyclingFacility).name
              console.log(this.$props.form.materials[i].facilityName);
            }
          })
          .catch(() => {
            self.$emit('update:fetchingData', false)
          })
      }

      this.materials = this.$store.getters.materials()
      if (!this.materials || this.materials.length === 0) {
        const self = this
        this.$emit('update:fetchingData', true)
        getMaterials()
          .then((response) => {
            self.materials = response
            self.$emit('update:fetchingData', false)
          })
          .catch(() => {
            self.$emit('update:fetchingData', false)
          })
      }
      const self = this;
      this.$props.form.materials.forEach((material, index) => {
        this.$props.form.materials[index].uuid = this.uuidv4();
        this.originalActuals[index] = material.quantityActual
      })

      //$('#receiptFile-0').addClass('required');
    },
    methods: {
      // this is silly
      capitalize: function (lowercase) {
        return capitalize(lowercase)
      },
      facilitySelected: function (facility) {
        //get current material and update facility info
        if (facility && facility.id) {
          this.$props.form.materials[this.currMaterialIndex].linktoRecyclingFacility = facility.id
          this.$props.form.materials[this.currMaterialIndex].facility = facility
        }
      },
      isFacilityNameError(index) {
        return isNullOrEmpty(this.$props.form.materials[index].linktoRecyclingFacility) || this.$props.form.materials[index].linktoRecyclingFacility.length == 0;
      },
      isMaterialNameError(index) {
        return isNullOrEmpty(this.$props.form.materials[index].materialType);
      },
      isTotalPercentageError(index) {
        let sum = 0;
        this.$props.form.materials.forEach((material) => {
          sum += +material.quantityActual
        })
        return ((sum / +this.$props.form.materialActual) * 100) < 70;
      },
      isTotalPercentageMaxError(index) {
        let sum = 0;
        this.$props.form.materials.forEach((material) => {
          sum += +material.quantityActual
        })
        return ((sum / +this.$props.form.materialActual) * 100) > 100;
      },
      isMaterialSumGreaterError() {
        let sum = 0;
        this.$props.form.materials.forEach((material) => {
          sum = +sum + +material.quantityEstimate
        })
        return sum > this.$props.form.materialEstimate;
      },
      isMaterialAmountError(index) {
        return isNullOrEmpty(this.$props.form.materials[index].quantityEstimate);
      },
      isMaterialActualError(index) {
        return isNullOrEmpty(this.$props.form.materials[index].quantityActual);
      },
      isOtherDescriptionError(index) {
        return this.$props.form.materials[index] == 'Other' && isNullOrEmpty(this.$props.form.materials[index].overrideName);
      },
      addMaterial() {
        var material = new Material();
        material.uuid = this.uuidv4();
        this.$props.form.materials.push(material);
        this.$set(this.showAstrisk, material.uuid, true);

      },
      removeMaterial(index) {
        console.log('delete: ' + index)
        let materials = this.$props.form.materials.splice(index, 1);
        //materials.splice(index, 1);
        this.$set(this.$props.form.materials, materials);

      },
      isMaterialOverrideNameError(index) {
        if (this.$props.form.materials[index].name != 'Other') return false;

        return isNullOrEmpty(this.$props.form.materials[index].overrideName);
      },
      resetMaterialOverrideName(index) {
        if (this.$props.form.materials[index].name != 'Other') {
          this.$props.form.materials[index].overrideName = '';
        }
      },
      uuidv4: function () {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
          (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
        );
      },
      isActualsError(index) {
        if (this.form.materials != null) {
          var material = this.$props.form.materials[index];
          if (this.originalActuals[material.uuid] != material.quantityActual) {
            this.$set(this.showAstrisk, material.uuid, true);
          } else {
            this.$set(this.showAstrisk, material.uuid, false);
          }
        }
        document.getElementById('receiptFile-' + index).classList.add('is-invalid');
        this.$nextTick(() => {
          // code to execute after the DOM is updated
        });
        return true
      },
      openMaterial(index) {
        this.currMaterialIndex = index
        document.getElementById('collapse-' + index).style.display = 'block'
        document.getElementById('collapse-' + index).classList.add('show')

        var i = 0;
        while (document.getElementById('collapse-' + i)) {
          if (i != index) {
            document.getElementById('collapse-' + i).style.display = 'none'
            document.getElementById('collapse-' + i).classList.remove('show')
          }

          i++
        }
      }
    },
    computed: {
      isVariance: function () {
        return this.form.varianceCheckPublicHealth ||
          this.form.varianceCheckFinancialBurden ||
          this.form.varianceCheckCourtOrder
      }
    }
  }
</script>
